module.exports = __webpack_public_path__ + "static/media/lpf_right.cfcdc962.png";